'use client';

import { type PropsWithChildren, useContext, useState } from 'react';
import { Dispatch, SetStateAction, createContext } from 'react';
import { DEFAULT_DISABLED_SELL } from '../TradeDrawer/useTradeSellDisabler/useTradeSellDisabler';

interface TradeContextValue {
  isSellingDisabled: boolean;
  isPortfolioEmpty: boolean;
  isUserHavingSavingsPlans: boolean;
  setSellButtonDisablerKeys: Dispatch<SetStateAction<string[]>>;
  setIsUserHavingSavingsPlans: Dispatch<SetStateAction<boolean>>;
}

const TradeContext = createContext<TradeContextValue>({} as TradeContextValue);

const TradeProvider = ({ children }: PropsWithChildren) => {
  const [sellButtonDisablerKeys, setSellButtonDisablerKeys] = useState<
    string[]
  >([DEFAULT_DISABLED_SELL]);

  const [isUserHavingSavingsPlans, setIsUserHavingSavingsPlans] =
    useState(false);

  return (
    <TradeContext.Provider
      value={{
        isSellingDisabled: sellButtonDisablerKeys.length > 0,
        isPortfolioEmpty: sellButtonDisablerKeys.includes(
          'EMPTY_PORTFOLIO_SELL_DISABLED',
        ),
        isUserHavingSavingsPlans,
        setIsUserHavingSavingsPlans,
        setSellButtonDisablerKeys,
      }}
    >
      {children}
    </TradeContext.Provider>
  );
};

function useTradeContext() {
  const contextValue = useContext(TradeContext);

  if (contextValue === null) {
    throw new Error('useTrade must be used within a TradeContextProvider');
  }

  return contextValue;
}

export { TradeProvider, useTradeContext, TradeContext };
